// assets/custom-product-page.js
//
// Handles:
// - Product / variant swatches
// - Price / compare-at price
// - Product image
// - Variant availability
// - URL variant updates
// - Recently viewed products
// - Wishlist
// - Product tabs
// - Main quantity stepper
// - Product gallery / thumbnails
// - Accessories / addons
// - Horizon AJAX cart drawer refresh
//

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-product-swatches]');

  if (!root) return;

  // =====================================================
  // PRODUCT DATA
  // =====================================================

  const dataScript = root.querySelector('[data-swatch-data]');

  if (!dataScript) {
    console.warn('Swatch data element not found.');
    return;
  }

  let products = [];

  try {
    products = JSON.parse(dataScript.textContent || '[]');
  } catch (error) {
    console.error('Unable to parse product swatch data:', error);
    return;
  }

  // =====================================================
  // MAIN ELEMENTS
  // =====================================================

  const swatches =
    root.querySelectorAll('[data-swatch-handle]');

  const titleEl =
    root.querySelector('[data-swatch-title]');

  const priceEl =
    root.querySelector('[data-swatch-price]');

  const comparePriceEl =
    root.querySelector('[data-swatch-compare-price]');

  const vendorEl =
    root.querySelector('[data-swatch-vendor]');

  const skuEl =
    root.querySelector('[data-swatch-sku]');

  const descriptionEl =
    root.querySelector('[data-swatch-description]');

  const variantInput =
    root.querySelector('[data-swatch-variant-id]');

  const submitBtn =
    root.querySelector(
      '[data-swatch-cart-form] button[type="submit"]'
    );

  // =====================================================
  // CURRENT PRODUCT
  // =====================================================

  let currentProduct = products[0] || null;

// =====================================================
// ADD-ONS
// =====================================================
//
// Main product variants and add-ons are completely
// independent.
//
// Main variant:
// - Single select
//
// Add-ons:
// - Single select
//
// Selecting one NEVER disables or clears the other.
// =====================================================

const addonCheckboxes =
  root.querySelectorAll('[data-addon-checkbox]');

addonCheckboxes.forEach((checkbox) => {
  checkbox.dataset.unavailable =
    checkbox.disabled ? 'true' : 'false';
});


/*
 * Keep this function for compatibility with any
 * other code that may call root.__setAddonsLocked().
 *
 * IMPORTANT:
 * It no longer locks/disables anything.
 */
function setAddonsLocked(locked) {
  addonCheckboxes.forEach((checkbox) => {

    /*
     * Never disable add-ons because of a
     * main product variant selection.
     */
    if (
      checkbox.dataset.unavailable === 'true'
    ) {
      return;
    }

    checkbox.disabled = false;

    const item =
      checkbox.closest('[data-addon-item]');

    if (item) {
      item.classList.remove('is-locked');
    }

  });
}

root.__setAddonsLocked =
  setAddonsLocked;


/*
 * Make sure add-ons are enabled on initial load.
 */
setAddonsLocked(false);


  // =====================================================
  // SHOPIFY MONEY FORMATTER
  // =====================================================

  function formatShopifyMoney(cents) {
    const amount = Number(cents || 0);

    if (
      typeof Shopify !== 'undefined' &&
      typeof Shopify.formatMoney === 'function'
    ) {
      return Shopify.formatMoney(
        amount,
        window.Shopify?.money_format || '{{amount}}'
      );
    }

    return '£' + (amount / 100).toFixed(2);
  }

  // =====================================================
  // UPDATE MAIN PRODUCT IMAGE
  // =====================================================

  function updateMainProductImage(image, altText) {
    if (!image) return;

    const currentImageEl =
      root.querySelector('[data-swatch-image]');

    if (!currentImageEl) return;

    currentImageEl.src = image;
    currentImageEl.alt = altText || '';
  }

  // =====================================================
  // UPDATE GALLERY ACTIVE THUMBNAIL
  // =====================================================

  function updateActiveGalleryImage(mediaId) {
    if (!mediaId) return;

    root
      .querySelectorAll('.custom-product__thumb')
      .forEach((thumb) => {
        thumb.classList.remove('active');

        if (
          String(thumb.dataset.mediaId) ===
          String(mediaId)
        ) {
          thumb.classList.add('active');
        }
      });
  }

  // =====================================================
  // UPDATE VARIANT INFORMATION
  // =====================================================

  function updateVariantUI(variant, productData) {
    if (!variant) return;

    if (titleEl) {
      titleEl.textContent =
        variant.title || productData?.title || '';
    }

    if (priceEl) {
      priceEl.textContent =
        variant.price || '';
    }

    if (comparePriceEl) {
      const hasComparePrice =
        variant.compare_price &&
        variant.compare_price !== variant.price;

      if (hasComparePrice) {
        comparePriceEl.textContent =
          variant.compare_price;

        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    if (descriptionEl) {
      descriptionEl.innerHTML =
        variant.description ||
        productData?.description ||
        '';
    }

    if (variant.image) {
      updateMainProductImage(
        variant.image,
        variant.title || productData?.title || ''
      );
    }

    if (variant.media_id) {
      updateActiveGalleryImage(
        variant.media_id
      );
    }

    if (variantInput) {
      variantInput.value = variant.id;
    }

    if (submitBtn) {
      submitBtn.disabled = !variant.available;

      submitBtn.textContent =
        variant.available
          ? 'Add to cart'
          : 'Sold out';
    }
  }

  // =====================================================
  // UPDATE URL WITH VARIANT
  // =====================================================

  function updateVariantURL(handle, variantId) {
    const currentUrl =
      new URL(window.location.href);

    if (variantId) {
      currentUrl.searchParams.set(
        'variant',
        variantId
      );

      window.history.replaceState(
        {
          handle: handle,
          variantId: variantId
        },
        '',
        currentUrl.toString()
      );
    } else {
      currentUrl.searchParams.delete('variant');

      window.history.replaceState(
        {
          handle: handle
        },
        '',
        currentUrl.toString()
      );
    }
  }

  // =====================================================
  // SWATCH CLICK HANDLER
  // =====================================================

  swatches.forEach((swatch) => {
    swatch.addEventListener(
      'click',
      () => {
        const variantId =
          swatch.getAttribute('data-variant-id');

        const handle =
          swatch.getAttribute('data-swatch-handle');

        const wasActive =
          swatch.classList.contains('is-active');

    swatches.forEach((item) => {
  item.classList.remove('is-active');
});

if (wasActive) {
  return;
}

swatch.classList.add('is-active');
        // =================================================
        // NATIVE SHOPIFY VARIANT SWATCH
        // =================================================

        if (variantId) {
          const productData =
            products.find(
              (item) =>
                item.handle === handle
            );

          if (
            !productData ||
            !productData.variants
          ) {
            console.warn(
              'No preloaded variant data for handle:',
              handle
            );
            return;
          }

          const variant =
            productData.variants.find(
              (item) =>
                String(item.id) ===
                String(variantId)
            );

          if (!variant) {
            console.warn(
              'Selected variant was not found:',
              variantId
            );
            return;
          }

          currentProduct = productData;

          updateVariantUI(
            variant,
            productData
          );

          updateVariantURL(
            handle,
            variant.id
          );

          updateActiveColorLabel(handle);
          updateWishlistButton();

          return;
        }

        // =================================================
        // LINKED PRODUCT SWATCH SYSTEM
        // =================================================

        const product =
          products.find(
            (item) =>
              item.handle === handle
          );

        if (!product) {
          console.warn(
            'Linked product not found:',
            handle
          );
          return;
        }

        currentProduct = product;

        if (titleEl) {
          titleEl.textContent =
            product.title || '';
        }

        if (priceEl) {
          priceEl.textContent =
            product.price || '';
        }

        if (comparePriceEl) {
          if (
            product.compare_price &&
            product.compare_price !==
              product.price
          ) {
            comparePriceEl.textContent =
              product.compare_price;

            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }

        if (vendorEl) {
          vendorEl.textContent =
            product.vendor || '';
        }

        if (skuEl) {
          skuEl.textContent =
            product.sku || '';
        }

        if (product.image) {
          updateMainProductImage(
            product.image,
            product.title
          );
        }

        if (descriptionEl) {
          descriptionEl.innerHTML =
            product.description || '';
        }

        if (variantInput) {
          variantInput.value =
            product.variant_id || '';
        }

        if (submitBtn) {
          submitBtn.disabled =
            !product.available;

          submitBtn.textContent =
            product.available
              ? 'Add to cart'
              : 'Sold out';
        }

        updateVariantURL(
          product.handle,
          null
        );

        if (product.title) {
          document.title =
            product.title;
        }

        updateActiveColorLabel(
          product.handle
        );

        updateWishlistButton();

        trackCurrentProduct();
        renderRecentlyViewed();
      }
    );
  });

  // =====================================================
  // RECENTLY VIEWED PRODUCTS
  // =====================================================

  const STORAGE_KEY =
    'recentlyViewedProducts';

  function getRecentlyViewed() {
    try {
      return JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      ) || [];
    } catch (error) {
      console.warn(
        'Unable to read recently viewed products.',
        error
      );

      return [];
    }
  }

  function saveRecentlyViewed(list) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(list)
      );
    } catch (error) {
      console.warn(
        'Unable to save recently viewed products.',
        error
      );
    }
  }

  function trackCurrentProduct() {
    if (!currentProduct) return;

    let list =
      getRecentlyViewed();

    list =
      list.filter(
        (item) =>
          item.handle !==
          currentProduct.handle
      );

    list.unshift({
      handle:
        currentProduct.handle,

      title:
        currentProduct.title,

      price:
        currentProduct.price,

      image:
        currentProduct.image,

      url:
        currentProduct.url
    });

    list =
      list.slice(0, 6);

    saveRecentlyViewed(list);
  }

  function renderRecentlyViewed() {
    const container =
      root.querySelector(
        '[data-recently-viewed]'
      );

    const emptyMsg =
      root.querySelector(
        '[data-recently-viewed-empty]'
      );

    if (!container) return;

    const list =
      getRecentlyViewed()
        .filter(
          (item) =>
            !currentProduct ||
            item.handle !==
            currentProduct.handle
        );

    container
      .querySelectorAll(
        '.custom-product__related-item'
      )
      .forEach(
        (element) =>
          element.remove()
      );

    if (list.length === 0) {
      if (emptyMsg) {
        emptyMsg.style.display = '';
      }

      return;
    }

    if (emptyMsg) {
      emptyMsg.style.display = 'none';
    }

    list.forEach((item) => {
      const a =
        document.createElement('a');

      a.href =
        item.url || '#';

      a.className =
        'custom-product__related-item';

      const img =
        document.createElement('img');

      img.src =
        item.image || '';

      img.alt =
        item.title || '';

      const span =
        document.createElement('span');

      const titleSpan =
        document.createElement('span');

      titleSpan.className =
        'custom-product__related-title';

      titleSpan.textContent =
        item.title || '';

      const priceSpan =
        document.createElement('span');

      priceSpan.className =
        'custom-product__related-price';

      priceSpan.textContent =
        item.price || '';

      span.appendChild(titleSpan);
      span.appendChild(priceSpan);

      a.appendChild(img);
      a.appendChild(span);

      container.appendChild(a);
    });
  }

  // =====================================================
  // INITIAL RECENTLY VIEWED
  // =====================================================

  if (currentProduct) {
    trackCurrentProduct();
    renderRecentlyViewed();
  }

  // =====================================================
  // ACTIVE COLOR / ATTRIBUTE LABEL
  // =====================================================

  function updateActiveColorLabel(handle) {
    root
      .querySelectorAll(
        '[data-attr-title]'
      )
      .forEach((element) => {
        element.classList.toggle(
          'is-active-attr',
          element.getAttribute(
            'data-attr-title'
          ) === handle
        );
      });
  }

  // =====================================================
  // WISHLIST
  // =====================================================

  const WISHLIST_KEY =
    'wishlistProductHandles';

  const wishlistBtn =
    root.querySelector(
      '[data-wishlist-toggle]'
    );

  function getWishlist() {
    try {
      return JSON.parse(
        localStorage.getItem(
          WISHLIST_KEY
        )
      ) || [];
    } catch (error) {
      console.warn(
        'Unable to read wishlist.',
        error
      );

      return [];
    }
  }

  function updateWishlistButton() {
    if (!wishlistBtn) return;
    if (!currentProduct) return;

    const inWishlist =
      getWishlist().includes(
        currentProduct.handle
      );

    wishlistBtn.innerHTML =
      inWishlist
        ? '&#9829; Added to wishlist'
        : '&#9825; Add to wishlist';

    wishlistBtn.classList.toggle(
      'is-active',
      inWishlist
    );
  }

  if (wishlistBtn) {
    wishlistBtn.addEventListener(
      'click',
      () => {
        if (!currentProduct) return;

        let list =
          getWishlist();

        if (
          list.includes(
            currentProduct.handle
          )
        ) {
          list =
            list.filter(
              (handle) =>
                handle !==
                currentProduct.handle
            );
        } else {
          list.push(
            currentProduct.handle
          );
        }

        try {
          localStorage.setItem(
            WISHLIST_KEY,
            JSON.stringify(list)
          );
        } catch (error) {
          console.warn(
            'Unable to save wishlist.',
            error
          );
        }

        updateWishlistButton();
      }
    );
  }

  updateWishlistButton();

  // =====================================================
  // DESCRIPTION / ADDITIONAL INFORMATION TABS
  // =====================================================

  const tabButtons =
    root.querySelectorAll(
      '[data-tab-target]'
    );

  const tabPanels =
    root.querySelectorAll(
      '[data-tab-panel]'
    );

  tabButtons.forEach((button) => {
    button.addEventListener(
      'click',
      () => {
        const target =
          button.getAttribute(
            'data-tab-target'
          );

        if (!target) return;

        tabButtons.forEach(
          (item) =>
            item.classList.remove(
              'is-active'
            )
        );

        tabPanels.forEach(
          (panel) =>
            panel.classList.remove(
              'is-active'
            )
        );

        button.classList.add(
          'is-active'
        );

        const targetPanel =
          root.querySelector(
            `[data-tab-panel="${target}"]`
          );

        if (targetPanel) {
          targetPanel.classList.add(
            'is-active'
          );
        }
      }
    );
  });

  // =====================================================
  // MAIN PRODUCT QUANTITY STEPPER
  // =====================================================

  const qtyInput =
    root.querySelector(
      '[data-qty-input]'
    );

  const qtyMinus =
    root.querySelector(
      '[data-qty-minus]'
    );

  const qtyPlus =
    root.querySelector(
      '[data-qty-plus]'
    );

  if (
    qtyInput &&
    qtyMinus &&
    qtyPlus
  ) {
    qtyMinus.addEventListener(
      'click',
      () => {
        const currentValue =
          parseInt(
            qtyInput.value || '1',
            10
          );

        const value =
          Math.max(
            1,
            currentValue - 1
          );

        qtyInput.value =
          value;

        qtyInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    );

    qtyPlus.addEventListener(
      'click',
      () => {
        const currentValue =
          parseInt(
            qtyInput.value || '1',
            10
          );

        const value =
          currentValue + 1;

        qtyInput.value =
          value;

        qtyInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    );
  }

  // =====================================================
  // GALLERY
  // =====================================================

  const mainMedia =
    root.querySelector(
      '.custom-product__main-media'
    );

  const thumbsContainer =
    root.querySelector(
      '[data-gallery-thumbs]'
    );

  const prevButton =
    root.querySelector(
      '[data-gallery-prev]'
    );

  const nextButton =
    root.querySelector(
      '[data-gallery-next]'
    );

  function updateGalleryArrows() {
    if (
      !thumbsContainer ||
      !prevButton ||
      !nextButton
    ) {
      return;
    }

    const maxScroll =
      Math.max(
        0,
        thumbsContainer.scrollWidth -
        thumbsContainer.clientWidth
      );

    prevButton.disabled =
      thumbsContainer.scrollLeft <= 0;

    nextButton.disabled =
      thumbsContainer.scrollLeft >=
      maxScroll - 2;
  }

  function scrollThumbnails(direction) {
    if (!thumbsContainer) return;

    const firstThumb =
      thumbsContainer.querySelector(
        '.custom-product__thumb'
      );

    const scrollAmount =
      firstThumb
        ? firstThumb.offsetWidth + 10
        : 90;

    thumbsContainer.scrollBy({
      left:
        direction *
        scrollAmount *
        3,
      behavior: 'smooth'
    });
  }

  if (prevButton) {
    prevButton.addEventListener(
      'click',
      () => {
        scrollThumbnails(-1);
      }
    );
  }

  if (nextButton) {
    nextButton.addEventListener(
      'click',
      () => {
        scrollThumbnails(1);
      }
    );
  }

  if (thumbsContainer) {
    thumbsContainer.addEventListener(
      'scroll',
      updateGalleryArrows
    );

    window.addEventListener(
      'resize',
      updateGalleryArrows
    );
  }

  // =====================================================
  // GALLERY THUMBNAIL CLICK
  // =====================================================

  root
    .querySelectorAll('.custom-product__thumb')
    .forEach((thumb) => {
      thumb.addEventListener(
        'click',
        () => {
          root
            .querySelectorAll(
              '.custom-product__thumb'
            )
            .forEach((item) => {
              item.classList.remove(
                'active'
              );
            });

          thumb.classList.add(
            'active'
          );

          const type =
            thumb.dataset.mediaType;

          const thumbnailImage =
            thumb.querySelector('img');

          if (
            !thumbnailImage ||
            !mainMedia
          ) {
            return;
          }

          if (type === 'image') {
            const fullImageUrl =
              thumbnailImage.dataset.fullSrc ||
              thumbnailImage.src;

            mainMedia.innerHTML = `
              <img
                id="MainMedia"
                data-swatch-image
                src="${fullImageUrl}"
                alt="${thumbnailImage.alt || ''}"
              >
            `;

            return;
          }

          if (type === 'video') {
            mainMedia.innerHTML = `
              <img
                id="MainMedia"
                data-swatch-image
                src="${thumbnailImage.src}"
                alt="${thumbnailImage.alt || 'Video'}"
              >
              <span class="custom-product__video-note">
                Video preview
              </span>
            `;
          }
        }
      );
    });

  updateGalleryArrows();

  // =====================================================
  // ACCESSORIES / ADDONS
  // =====================================================

  const addonsBox =
    root.querySelector(
      '[data-addons]'
    );

  if (addonsBox) {
    const addonRows =
      addonsBox.querySelectorAll(
        '[data-addon-row]'
      );

    const totalElement =
      addonsBox.querySelector(
        '[data-addons-total]'
      );

    const addonsSubmitButton =
      addonsBox.querySelector(
        '[data-addons-submit]'
      );

    // ===================================================
    // ACCESSORY MONEY FORMAT
    // ===================================================

    function formatAddonMoney(cents) {
      const amount =
        Number(cents || 0);

      if (
        typeof Shopify !== 'undefined' &&
        typeof Shopify.formatMoney === 'function'
      ) {
        return Shopify.formatMoney(
          amount,
          window.Shopify?.money_format ||
          '{{amount}}'
        );
      }

      return '£' +
        (amount / 100).toFixed(2);
    }

    // ===================================================
    // UPDATE ACCESSORY TOTAL
    // ===================================================

    function updateAddonTotal() {
      let total = 0;

      addonRows.forEach((row) => {
        const checkbox =
          row.querySelector(
            '[data-addon-checkbox]'
          );

        const input =
          row.querySelector(
            '[data-addon-qty-input]'
          );

        if (
          !checkbox ||
          !checkbox.checked
        ) {
          return;
        }

        const price =
          parseInt(
            row.dataset.price || '0',
            10
          );

        let quantity =
          parseInt(
            input?.value || '1',
            10
          );

        if (
          Number.isNaN(quantity) ||
          quantity < 1
        ) {
          quantity = 1;

          if (input) {
            input.value = 1;
          }
        }

        total +=
          price * quantity;
      });

      if (totalElement) {
        totalElement.textContent =
          formatAddonMoney(total);
      }
    }

    // ===================================================
    // ACCESSORY QUANTITY CONTROLS
    // ===================================================

    addonRows.forEach((row) => {
      const minus =
        row.querySelector(
          '[data-addon-qty-minus]'
        );

      const plus =
        row.querySelector(
          '[data-addon-qty-plus]'
        );

      const input =
        row.querySelector(
          '[data-addon-qty-input]'
        );

      const checkbox =
        row.querySelector(
          '[data-addon-checkbox]'
        );

      if (minus && input) {
        minus.addEventListener(
          'click',
          () => {
            let value =
              parseInt(
                input.value || '1',
                10
              );

            if (Number.isNaN(value)) {
              value = 1;
            }

            value =
              Math.max(
                1,
                value - 1
              );

            input.value =
              value;

            input.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );

            updateAddonTotal();
          }
        );
      }

      if (plus && input) {
        plus.addEventListener(
          'click',
          () => {
            let value =
              parseInt(
                input.value || '1',
                10
              );

            if (Number.isNaN(value)) {
              value = 1;
            }

            value++;

            input.value =
              value;

            input.dispatchEvent(
              new Event('change', {
                bubbles: true
              })
            );

            updateAddonTotal();
          }
        );
      }

      if (input) {
        input.addEventListener(
          'change',
          () => {
            let value =
              parseInt(
                input.value || '1',
                10
              );

            if (
              Number.isNaN(value) ||
              value < 1
            ) {
              value = 1;
            }

            input.value =
              value;

            updateAddonTotal();
          }
        );
      }

      if (checkbox) {
        checkbox.addEventListener(
          'change',
          updateAddonTotal
        );
      }
    });

    updateAddonTotal();

    // ===================================================
    // ADD MAIN PRODUCT + ACCESSORIES
    // ===================================================

    if (addonsSubmitButton) {
      addonsSubmitButton.addEventListener(
        'click',
        async (event) => {
          event.preventDefault();

          const selectedVariantInput =
            root.querySelector(
              '[data-swatch-variant-id]'
            );

          let mainVariant =
            selectedVariantInput?.value ||
            addonsBox.dataset.mainProduct ||
            '';

          mainVariant =
            String(mainVariant).trim();

          const items = [];

          // =================================================
          // MAIN PRODUCT
          // =================================================

          if (mainVariant) {
            let mainQuantity = 1;

            const mainQuantityInput =
              root.querySelector(
                '[data-qty-input]'
              );

            if (mainQuantityInput) {
              mainQuantity =
                parseInt(
                  mainQuantityInput.value || '1',
                  10
                );

              if (
                Number.isNaN(mainQuantity) ||
                mainQuantity < 1
              ) {
                mainQuantity = 1;
              }
            }

            const mainId =
              Number(mainVariant);

            if (
              Number.isFinite(mainId) &&
              mainId > 0
            ) {
              items.push({
                id: mainId,
                quantity: mainQuantity
              });
            }
          }

          // =================================================
          // SELECTED ACCESSORIES
          // =================================================

          addonRows.forEach((row) => {
            const checkbox =
              row.querySelector(
                '[data-addon-checkbox]'
              );

            const quantityInput =
              row.querySelector(
                '[data-addon-qty-input]'
              );

            if (
              !checkbox ||
              !checkbox.checked
            ) {
              return;
            }

            const variantId =
              Number(
                row.dataset.variantId
              );

            let quantity =
              parseInt(
                quantityInput?.value || '1',
                10
              );

            if (
              Number.isNaN(quantity) ||
              quantity < 1
            ) {
              quantity = 1;
            }

            if (
              Number.isFinite(variantId) &&
              variantId > 0
            ) {
              items.push({
                id: variantId,
                quantity: quantity
              });
            }
          });

          if (items.length === 0) {
            alert(
              'Please select a product or accessory.'
            );
            return;
          }

          addonsSubmitButton.disabled =
            true;

          const originalButtonText =
            addonsSubmitButton.textContent.trim();

          addonsSubmitButton.textContent =
            'ADDING...';

          try {
            const cartRoot =
              window.Shopify?.routes?.root ||
              '/';

            const response =
              await fetch(
                cartRoot + 'cart/add.js',
                {
                  method: 'POST',

                  headers: {
                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'
                  },

                  body:
                    JSON.stringify({
                      items: items
                    }),

                  credentials:
                    'same-origin',

                  cache:
                    'no-store'
                }
              );

            const data =
              await response
                .json()
                .catch(
                  () => ({})
                );

            if (
              !response.ok ||
              data.status
            ) {
              throw new Error(
                data.description ||
                data.message ||
                'Unable to add products to cart.'
              );
            }

            await refreshHorizonCart(
              data.sections || {}
            );

          } catch (error) {
            console.error(
              'Accessories cart error:',
              error
            );

            alert(
              error.message ||
              'Unable to add products to cart.'
            );
          } finally {
            addonsSubmitButton.disabled =
              false;

            addonsSubmitButton.textContent =
              originalButtonText;
          }
        }
      );
    }
  }

  // =====================================================
  // INITIAL VARIANT FROM URL
  // =====================================================

  const urlParams =
    new URLSearchParams(
      window.location.search
    );

  const urlVariantId =
    urlParams.get('variant');

  if (urlVariantId) {
    const matchingSwatch =
      root.querySelector(
        `[data-variant-id="${urlVariantId}"]`
      );

    if (matchingSwatch) {
      matchingSwatch.click();
    }
  }

  // =====================================================
  // HORIZON CART HELPERS
  // =====================================================

  function getShopifyRoot() {
    return (
      window.Shopify?.routes?.root ||
      '/'
    );
  }

  function getCartSectionIds() {
    const ids = [];

    document
      .querySelectorAll(
        'cart-items-component[data-section-id]'
      )
      .forEach((component) => {
        const id =
          component.dataset.sectionId;

        if (
          id &&
          !ids.includes(id)
        ) {
          ids.push(id);
        }
      });

    document
      .querySelectorAll(
        'cart-drawer-component[data-section-id], cart-drawer[data-section-id]'
      )
      .forEach((component) => {
        const id =
          component.dataset.sectionId;

        if (
          id &&
          !ids.includes(id)
        ) {
          ids.push(id);
        }
      });

    return ids;
  }

  function replaceRenderedCartSections(sections) {
    if (!sections || typeof sections !== 'object') {
      return;
    }

    Object.entries(sections).forEach(
      ([sectionId, html]) => {
        if (!html) return;

        try {
          const parser =
            new DOMParser();

          const doc =
            parser.parseFromString(
              html,
              'text/html'
            );

          const escapedId =
            typeof CSS !== 'undefined' &&
            typeof CSS.escape === 'function'
              ? CSS.escape(sectionId)
              : sectionId.replace(
                  /([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g,
                  '\\$1'
                );

          const newSection =
            doc.querySelector(
              `#shopify-section-${escapedId}`
            );

          const oldSection =
            document.querySelector(
              `#shopify-section-${escapedId}`
            );

          if (
            newSection &&
            oldSection
          ) {
            oldSection.replaceWith(
              newSection
            );

            return;
          }

          // Fallback for cases where the Shopify
          // wrapper is not present in the DOM.
          const newCartItems =
            doc.querySelector(
              `cart-items-component[data-section-id="${escapedId}"]`
            );

          const oldCartItems =
            document.querySelector(
              `cart-items-component[data-section-id="${escapedId}"]`
            );

          if (
            newCartItems &&
            oldCartItems
          ) {
            oldCartItems.replaceWith(
              newCartItems
            );
          }
        } catch (error) {
          console.warn(
            'Unable to replace cart section:',
            sectionId,
            error
          );
        }
      }
    );
  }

  async function requestCartSections(sectionIds) {
    if (!sectionIds.length) {
      return {};
    }

    const rootUrl =
      getShopifyRoot();

    const basePath =
      window.location.pathname || '/';

    const params =
      new URLSearchParams();

    params.set(
      'sections',
      sectionIds.join(',')
    );

    params.set(
      'sections_url',
      window.location.pathname
    );

    const response =
      await fetch(
        `${basePath}?${params.toString()}`,
        {
          method: 'GET',

          headers: {
            Accept:
              'application/json'
          },

          credentials:
            'same-origin',

          cache:
            'no-store'
        }
      );

    if (!response.ok) {
      throw new Error(
        'Unable to refresh the cart drawer.'
      );
    }

    return response.json();
  }

  async function getFreshCart() {
    const response =
      await fetch(
        getShopifyRoot() +
          'cart.js?_=' +
          Date.now(),
        {
          method: 'GET',

          headers: {
            Accept:
              'application/json'
          },

          credentials:
            'same-origin',

          cache:
            'no-store'
        }
      );

    if (!response.ok) {
      throw new Error(
        'Unable to read the current cart.'
      );
    }

    return response.json();
  }

  async function refreshHorizonCart(
    renderedSections = {}
  ) {
    let sections =
      renderedSections &&
      typeof renderedSections === 'object'
        ? renderedSections
        : {};

    const sectionIds =
      getCartSectionIds();

    /*
     * If the /cart/add.js response did not include
     * rendered sections, request them directly.
     */
    if (
      sectionIds.length &&
      Object.keys(sections).length === 0
    ) {
      sections =
        await requestCartSections(
          sectionIds
        );
    }

    /*
     * THIS is the important fix:
     *
     * Do not only dispatch cart:update.
     * Actually replace the old cart HTML with the
     * fresh server-rendered Horizon section HTML.
     */
    replaceRenderedCartSections(
      sections
    );

    /*
     * Get the real current cart so the cart count
     * and cart event contain the correct item count.
     */
    const cart =
      await getFreshCart();

    /*
     * Tell any Horizon cart components that the cart
     * has changed.
     */
    document.dispatchEvent(
      new CustomEvent(
        'cart:update',
        {
          bubbles: true,

          detail: {
            resource:
              cart,

            sourceId:
              'custom-product-page',

            data: {
              itemCount:
                cart.item_count,

              source:
                'product-form-component',

              sections:
                sections
            }
          }
        }
      )
    );

    /*
     * Give the browser a moment to connect the newly
     * inserted custom elements before opening the drawer.
     */
    await new Promise((resolve) => {
      requestAnimationFrame(() => {
        requestAnimationFrame(resolve);
      });
    });

    const freshDrawer =
      document.querySelector(
        'cart-drawer-component'
      ) ||
      document.querySelector(
        'cart-drawer'
      );

    if (
      freshDrawer &&
      typeof freshDrawer.open === 'function'
    ) {
      freshDrawer.open();

      return cart;
    }

    if (
      window.Shopify?.actions &&
      typeof window.Shopify.actions.openCart ===
        'function'
    ) {
      await window.Shopify.actions.openCart();

      return cart;
    }

    console.warn(
      'Horizon cart drawer element was not found.'
    );

    return cart;
  }

  // =====================================================
  // MAIN PRODUCT FORM - HORIZON AJAX CART
  // =====================================================

  const mainCartForm =
    root.querySelector(
      '[data-swatch-cart-form]'
    );

  if (mainCartForm) {
    mainCartForm.addEventListener(
      'submit',
      async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        const selectedVariantInput =
          root.querySelector(
            '[data-swatch-variant-id]'
          );

        const variantId =
          selectedVariantInput?.value?.trim();

        if (!variantId) {
          alert(
            'Please select a product variant.'
          );
          return;
        }

        const quantityInput =
          root.querySelector(
            '[data-qty-input]'
          );

        let quantity =
          parseInt(
            quantityInput?.value || '1',
            10
          );

        if (
          Number.isNaN(quantity) ||
          quantity < 1
        ) {
          quantity = 1;
        }

        if (quantityInput) {
          quantityInput.value =
            quantity;
        }

        const originalButtonText =
          submitBtn?.textContent?.trim() ||
          'Add to cart';

        if (submitBtn) {
          submitBtn.disabled =
            true;

          submitBtn.textContent =
            'ADDING...';
        }

        try {
          const cartRoot =
            getShopifyRoot();

          const cartAddUrl =
            cartRoot +
            'cart/add.js';

          const formData =
            new FormData(
              mainCartForm
            );

          formData.set(
            'id',
            variantId
          );

          formData.set(
            'quantity',
            String(quantity)
          );

          /*
           * Ask Shopify to render the exact Horizon
           * cart sections currently used on this page.
           */
          const sectionIds =
            getCartSectionIds();

          if (sectionIds.length) {
            formData.set(
              'sections',
              sectionIds.join(',')
            );

            formData.set(
              'sections_url',
              window.location.pathname
            );
          }

          const response =
            await fetch(
              cartAddUrl,
              {
                method: 'POST',

                headers: {
                  Accept:
                    'application/json'
                },

                body:
                  formData,

                credentials:
                  'same-origin',

                cache:
                  'no-store'
              }
            );

          const data =
            await response
              .json()
              .catch(
                () => ({})
              );

          if (
            !response.ok ||
            data.status
          ) {
            throw new Error(
              data.description ||
              data.message ||
              'Unable to add product to cart.'
            );
          }

          /*
           * Add succeeded.
           *
           * Now directly refresh the Horizon cart
           * HTML and open the drawer.
           */
          await refreshHorizonCart(
            data.sections || {}
          );

          console.log(
            'Product added successfully:',
            variantId
          );

        } catch (error) {
          console.error(
            'Custom product add-to-cart error:',
            error
          );

          alert(
            error.message ||
            'Unable to add product to cart.'
          );

        } finally {
          if (submitBtn) {
            submitBtn.disabled =
              false;

            submitBtn.textContent =
              originalButtonText;
          }
        }
      },
      true
    );
  }
});

// =====================================================
// MATCH DESCRIPTION / TABS TO SIDEBAR
// =====================================================

document.addEventListener(
  'DOMContentLoaded',
  function () {
    function matchDescriptionToSidebar() {
      // Only apply on desktop.
      if (window.innerWidth <= 1100) {
        document.documentElement.style.removeProperty(
          '--custom-description-height'
        );

        const tabs =
          document.querySelector(
            '.custom-product__tabs'
          );

        if (tabs) {
          tabs.style.minHeight = '';
        }

        return;
      }

      const productMain =
        document.querySelector(
          '.custom-product__main'
        );

      const tabs =
        document.querySelector(
          '.custom-product__tabs'
        );

      const sidebar =
        document.querySelector(
          '.custom-product__sidebar'
        );

      if (
        !productMain ||
        !tabs ||
        !sidebar
      ) {
        return;
      }

      const sidebarRect =
        sidebar.getBoundingClientRect();

      const tabsRect =
        tabs.getBoundingClientRect();

      const requiredHeight =
        sidebarRect.bottom -
        tabsRect.top;

      if (requiredHeight > 0) {
        tabs.style.minHeight =
          requiredHeight + 'px';
      } else {
        tabs.style.minHeight = '';
      }
    }

    matchDescriptionToSidebar();

    window.addEventListener(
      'load',
      function () {
        matchDescriptionToSidebar();
      }
    );

    window.addEventListener(
      'resize',
      function () {
        matchDescriptionToSidebar();
      }
    );

    const sidebar =
      document.querySelector(
        '.custom-product__sidebar'
      );

    if (
      sidebar &&
      window.ResizeObserver
    ) {
      const observer =
        new ResizeObserver(
          function () {
            matchDescriptionToSidebar();
          }
        );

      observer.observe(sidebar);
    }
  }
);
